import { Col, Row } from "antd";
import React, { useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";
import Form from "../../form-components/from";
import EndPoints from "../../../services/end-points";
import AppContext from "../../../context/app/context";
import OrderContext from "../../../context/order/context";
import { IStore } from "../../../models/store/response";
import {
  getOrderStatus,
} from "../../../models/order/enum";
import { addSearchToURL, filtersToQueryString, getFiltersFromURL, getKeywordFromURL } from "../../../utils/helpers/url";
import { useLocation } from "react-router-dom";

interface IProps { }

const OrderShortFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(OrderContext);

  const [store, setSorte] = useState<IStore[]>([]);
  const [loadingStore, setLoadingStore] = useState(true);

  const { direction } = useContext(AppContext);

  const location = useLocation();
    const [initialValues, setInitialValues] = useState<Record<string, any>>({});
  
    useEffect(() => {
      const filters = getFiltersFromURL();
  
      const initialValuesObj = {};
      filters.forEach((f) => {
        initialValuesObj[f.name] = f.value;
      });
  
      setInitialValues(initialValuesObj);
    }, [location.search]);
  
  useEffect(() => {
    const getStore = async () => {
      try {
        const { data } = await EndPoints.store.getAllStores({
          light: true,
          perPage: -1,
        });
        setSorte(data.data);
        setLoadingStore(false);
      } catch (error) {
      } finally {
        setLoadingStore(false);
      }
    };
    getStore();
  }, [direction]);

  const status = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <Form
      formId="order-short-filter"
      defaultValues={initialValues}
      onSubmit={(data) => {
        const keyword = getKeywordFromURL();
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: keyword,
          filters: [
            data?.storeId
              ? {
                name: "storeId",
                value: data.storeId,
                operation: "eq",
              }
              : undefined,
            data?.status
              ? {
                name: "status",
                value: data.status,
                operation: "eq",
              }
              : undefined,
          ].filter((f) => f),
        };
        const queryString = filtersToQueryString(filter.filters);
        window.history.replaceState(null, "", `?${queryString}`);
        addSearchToURL(keyword);
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="storeId"
            label={`${t("store")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              loading: loadingStore,
              options: store.map((store, index) => {
                return {
                  label: store.name,
                  value: store.id as number,
                };
              }),
            }}
          />
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              allowSearch: true,
              options: status.map((status, index) => {
                return {
                  label: t(getOrderStatus(status) as string),
                  value: status as number,
                };
              }),
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default OrderShortFilter;
